module.exports = __webpack_public_path__ + "static/media/fa-regular-400.16f04cc3.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-regular-400.eot
// module id = 301
// module chunks = 0